<template>
  <div>
    <div class=" mainLoader" v-if="loading">
    </div>
    <div class="realbody">
      <div class="top_summary">
        <div class="container">
          <div class="row">
            <div class="col-md-6" style="padding: 70px 0px;">
              <p class="top_summary_header mplus2p-m spacing4 noiseblack">{{$t('cp_title')}}</p>
              <p class="top_summary_comment mplus2p-r spacing1-2 noiseblack">{{$t('cp_desc')}}</p>
            </div>
            <div class="col-md-6" style="text-align: center;">
              <img src="../../assets/imgs/companyprofile.png" class="pman" />
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row" style="margin-top: 40px;">
          <div class="col-md-3">
            <app-company-sidebar :selectedItem="selectedItem"></app-company-sidebar>
          </div>
          <div class="col-md-9">
            <div class="page_title">
              <span class="page_title_comment mplus2p-m spacing1-2 noiseblack">{{$t('ep_button')}}</span>
            </div>

            <div class="row pview">
              <form style="margin-top: 30px; display: contents;" name="form" @submit.prevent="doUpdateProfile" validate>
                <div class="col-md-3 text-center upload-btn-wrapper">
                  <video v-if="company_user_video"  height="150" width="150" controls>
                      <source :src="company_user_video">
                  </video>
                  <img class="company"  v-if="cropImg" :src="cropImg"  @click="editProfileImageButtonClick()"/>
                  <img class="avatar" style="width: 150px; height:150px;" v-if="!cropImg && !company_user_video" src="../../assets/imgs/default-user.png" @click="editProfileImageButtonClick()" />
                  <progress-bar v-if="processUpload > 0 && !processUploadSuccess"
                    :options="options"
                    :value="processUpload"
                    />

                  <span class="camera imgbtn" @click="editProfileImageButtonClick()">
                    <i class="fa fa-camera" aria-hidden="true"></i>
                  </span>
                  <input type="file" name="myfile" class="d-none" ref="myfile" @change="readUrl($event)" />
                </div>
                <div class="col-md-9">
                  <div class="row" style="margin-top: 30px;">
                    <div class="col-md-6 input form-group" :class="{ invalid: $v.last_name.$error && $v.last_name.$dirty}" style="margin-top: 20px;">
                      <label class="peditlabel mplus2p-m spacing1-2 noiseblack">{{$t('ep_lastname')}} <span style="color: red;">*</span></label>
                      <input
                            type="text"
                            class="peditboxes peditinput form-control"
                            name="lastname"
                            v-model="$v.last_name.$model"
                            autofocus
                            :placeholder="$t('unify_test')" />
                        <div class="help-block" style="margin-left: 1.3rem!important" v-if="!$v.last_name.req && $v.last_name.$dirty">{{$t('required_filed')}}
                       </div>

                    </div>
                    <div class="col-md-6 form-group input" :class="{ invalid: $v.first_name.$error && $v.first_name.$dirty}" style="margin-top: 20px;">
                      <label class="peditlabel mplus2p-m spacing1-2 noiseblack">{{$t('ep_firstname')}} <span style="color: red;">*</span></label>
                      <input
                            type="text"
                            class="peditboxes peditinput form-control"
                            name="firstname"
                            v-model.trim="$v.first_name.$model"
                            autofocus
                            :placeholder="$t('unify_test')" />
                         <div class="help-block " style="margin-left: 1.3rem!important" v-if="!$v.first_name.req && $v.first_name.$dirty">
                          {{$t('required_filed')}}
                        </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-12" style="height: 38px;"></div>
                <div class="col-md-3">
                  <label class="peditlabel mplus2p-m spacing1-2 noiseblack">{{$t('r_email')}}</label>
                </div>
                <div class="col-md-9 form-group">
                  <input disabled v-model="email" placeholder="yourname@example.com" type="email" class="peditboxes peditinput linput form-control" name="policy" required autofocus style="margin-top: 10px;" />
                </div>

                <div class="col-md-12 pv_btnpanel mt-5">
                  <button type="submit" class="btn bluebtn updatebtn">{{$t('cp_edit_update')}}</button>
                </div>
              </form>
            </div>
            <div>
              <change-password @stopLoding="loadingStop"></change-password>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="comapanyUserProfileImage" role="dialog">
      <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" style="color: #3d7dd8;">&times;</button>
          </div>
          <div class="modal-body m-cropper-container m-cropper-hide" style="text-align: center;">
            <div style="width: 400px; height:300px;  display: inline-block;">
            <vue-cropper ref='cropper'
                      :guides="true"
                      :view-mode="2"
                      drag-mode="crop"
                      :min-container-width="400"
                      :min-container-height="300"
                      :background="false"
                      :aspectRatio='1'
                      :zoomable='false'
                      :zoomOnTouch='false'
                      :zoomOnWhee='false'
                      :rotatable="true" :src="imgSrc" alt="Source Image" :img-style="{ 'width': '400px', 'height': '300px' }">
              </vue-cropper>
            </div>
            <p></p>
            <span class="result rounded" v-if="cropImg">
              <img class="avatar" style="width: 147px; height: 147px; border-radius: 100px" :src="cropImg">
            </span>
            <span class="result rounded" v-if="!cropImg">
              <img class="avatar" style="width: 147px; height: 147px; border-radius: 100px" src="../../assets/imgs/companydummy.png">
            </span>
            <br>
            <br>
            <button @click="cropImage" v-if="imgSrc != ''">{{$t('cp_image_crop')}}</button>
          </div>
          <div class="modal-footer">
             <button class='btn bluebtn DoneCrop' @click="uplodImage" data-dismiss="modal">{{$t('cp_done')}}</button>
          </div>
        </div>

      </div>
    </div>

    <button type="button" class="d-none" data-toggle="modal" data-backdrop="static" data-keyboard="false" data-target="#comapanyUserProfileImage" ref="myBtnCompanyUserProfile">
      Launch demo modal
    </button>
  </div>
</template>

<script>
if (typeof jQuery === "undefined") {
  if (typeof require === "function") {
    window.jQuery = window.$ = require("jquery");
  } else {
    window.jQuery = $;
  }
}
import axios from "axios";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import companySidebar from "./company_sidebar";
import changePassword from "./changeCompanyUserPassword/changePassword";
import {EventBus} from "./../../main.js";
export default {
  mixins: [validationMixin],

  validations: {
    first_name: { req: required },
    last_name: { req: required }
  },
  data() {
    return {
      selectedItem: 4,
      loading: false,
      cropImg: "",
      imgSrc: "",
      company_user_video: '',

      options: {
        text: {
          color: '#FFFFFF',
          shadowEnable: true,
          shadowColor: '#000000',
          fontSize: 14,
          fontFamily: 'Helvetica',
          dynamicPosition: false,
          hideText: false
        },
        progress: {
          color: '#3d7dd8',
          backgroundColor: '#C0C0C0'
        },
        layout: {
          height: 35,
          width: 140,
          verticalTextAlign: 61,
          horizontalTextAlign: 43,
          zeroOffset: 0,
          strokeWidth: 30,
          progressPadding: 0,
          type: 'line'
        }
      },
      processUpload: 0,
      processUploadSuccess: false,

      img: [],
      image: "",
      imageBlob: "",
      first_name: "",
      last_name: "",
      email: ''
    };
  },
  mounted() {
    var data = JSON.parse(localStorage.getItem("user"));
    var uId = data.user_token;
    var cId = data.company.company_token;
    if (uId != this.$route.params.uid || cId != this.$route.params.cid) {
      this.$router.push("/global/PageNotFound");
    }
    var itemId = data.id;
    this.getEngineerProfile(itemId);
  },
  components: {
    appCompanySidebar: companySidebar,
    changePassword
  },
  methods: {
    loadingStop(value){
      this.loading = value;
    },
    editProfileImageButtonClick() {
      this.$refs["myfile"].click();
    },
    openModal(template) {
      this.modalRef = this.modalService.show(template);
    },

    b64toBlob(b64Data, contentTyper) {
      let contentType = contentTyper || "";
      let sliceSize = 512;

      let byteCharacters = atob(b64Data);
      let byteArrays = [];

      for (
        let offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        let slice = byteCharacters.slice(offset, offset + sliceSize);

        let byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        let byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      let blob = new Blob(byteArrays, { type: contentType });
      return blob;
    },

    convertToBlob(bsdata) {
      // Split the base64 string in data and contentType
      let block = bsdata.split(";");
      // Get the content type of the image
      let contentType = block[0].split(":")[1]; // In this case "image/gif"
      // get the real base64 content of the file
      let realData = block[1].split(",")[1]; // In this case "R0lGODlhPQBEAPeoAJosM...."

      // Convert it to a blob to upload
      let blob = this.b64toBlob(realData, contentType);

      return blob;
    },

    rotateBase64Image(base64ImageSrc) {
      let canvas = document.createElement("canvas");
      let img = new Image();
      img.src = base64ImageSrc;
      canvas.width = img.width;
      canvas.height = img.height;
      let context = canvas.getContext("2d");
      context.translate(img.width, img.height);
      context.rotate(180 * Math.PI / 180);
      context.drawImage(img, 0, 0);
      return canvas.toDataURL();
    },

    clickedSex(flag) {
      if (flag === 0) {
        this.sex = "male";
        $(".womenradio").removeClass("wchosen");
        $(".manradio").addClass("mchosen");
      }
      if (flag === 1) {
        this.sex = "female";
        $(".manradio").removeClass("mchosen");
        $(".womenradio").addClass("wchosen");
      }
    },
    cropImage() {
      this.cropLoader = true;
      setTimeout(() => {
        this.company_user_video = ''
        this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
        this.cropLoader = false;
      }, 500);

      var data = this.$refs.cropper.getCroppedCanvas({
        width: 160,
        height: 90,
        minWidth: 256,
        minHeight: 256,
        maxWidth: 4096,
        maxHeight: 4096,
        fillColor: "#fff",
        imageSmoothingEnabled: false,
        imageSmoothingQuality: "high"
      });

      fetch(data.toDataURL())
        .then(obj => {
          return obj.blob();
        })
        .then(blob => {
          this.imageBlob = blob;
        });
    },
    rotate() {
      // guess what this does :)
      this.$refs.cropper.rotate(90);
    },
    readUrl(e) {
      const file = e.target.files[0];
      // this.img.push(e.target.files[0].name);
      if (file.type === 'image/gif' || file.type === 'video/mp4') {
        this.processUploadSuccess = false;
        if (file.type === 'video/mp4') {
          if (file.size > 5242880) {
						this.$toaster.error('File size must not be more than 5 MB');
						return;
					}
          var reader = new FileReader();
          reader.onload = event => {
            this.cropImg = ''
            this.company_user_video = event.target.result;
            this.uplodImage();
          }
          reader.readAsDataURL(file);
        }else{
          var reader = new FileReader();
          reader.onload = event => {
            this.company_user_video = ''
            this.cropImg = event.target.result;
            this.uplodImage();
          }
          reader.readAsDataURL(file);
        }
        this.imageBlob = file
        e.target.value = '';
        return;
      }

       if (!file.type.includes("image/") || !file.type === 'image/gif' || !file.type === 'video/mp4') {
        this.$toaster.error('Please select an image or GIF or MP4 file');
        return;
      }
      if (typeof FileReader === "function") {
        var reader = new FileReader();
        reader.onload = event => {
          //vm.image = event.target.result;
          this.imgSrc = event.target.result;
          // rebuild cropperjs with the updated source
          this.$refs.cropper.replace(event.target.result);
          this.showModal();
        };
        reader.readAsDataURL(file);
      } else {
        alert("Sorry, FileReader API not supported");
      }
      e.target.value = "";
    },
    showModal() {
      const elem = this.$refs.myBtnCompanyUserProfile;
      elem.click();
    },
    uplodImage(){
        var formData = new FormData();
        if (this.imageBlob.type === "image/png"  || this.imageBlob.type === 'image/gif' || this.imageBlob.type === 'image/jpg' || this.imageBlob.type === 'image/jpeg') {
          formData.append("image", this.imageBlob, 'temp.png');
        }else{
            formData.append("video", this.imageBlob, this.imageBlob.name);
        }
        const vm = this
        var config = {
            onUploadProgress: function(progressEvent) {
              vm.processUpload = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
            }
          };
        axios
          .post(
            "/avatar-upload?token=" + localStorage.getItem("token"),
            formData,
            config,
            {
              headers: { "X-localization": localStorage.getItem("lan") }
            },

          )
          .then(res => {
            let thisVue = this;
            if (!res.data.result) {
              if (res.data[0]) {
                this.$toaster.error(res.data[0]);
                this.$store.dispatch("logout");
              }
              if (res.data.errors) {
                for (var i = 0; i < res.data.errors.length; i++) {
                  this.$toaster.error(res.data.errors[i].message);
                }
              }
              this.loading = false;
            } else {
              this.processUploadSuccess = true;
              var user = JSON.parse(localStorage.getItem("user"))
              user.image = res.data.file;
              localStorage.setItem("user", JSON.stringify(user));
              this.$toaster.success(thisVue.$t('success_file_upload'));
            }
          })
          .catch((error) => {
            console.log(error);
          });
    },

    getEngineerProfile(id) {
      this.loading = true;
      axios
        .get("/user/" + id, {
          headers: { "X-localization": localStorage.getItem("lan") }
        })
        .then(res => {
          if (!res.data.result) {
            if (res.data[0]) {
              this.$toaster.error(res.data[0]);
              this.$store.dispatch("logout");
            }

            this.loading = false;
          } else {
            this.first_name = res.data.user.first_name;
            this.last_name = res.data.user.last_name;
            if (res.data.user.image.split(/\#|\?/)[0].split('.').pop().trim() === 'mp4') {
              this.company_user_video = res.data.user.image
            }else{
              this.cropImg = res.data.user.image;
            }

            this.desc = res.data.user.skill;
            this.email = res.data.user.email;
            this.sel_year = res.data.user.birthdate_year;
            this.sel_month = res.data.user.birthdate_month;
            this.sel_day = res.data.user.birthdate_day;
            this.sel_location = res.data.user.location;
            this.sel_experience = res.data.user.experience;
            this.sel_wantedJob = res.data.user.wanted_job;
            this.policy = res.data.user.policy;
            if (res.data.user.employment_form == null) {
              this.sel_wantedJobTypes = "";
            } else {
              this.sel_wantedJobTypes = res.data.user.employment_form;
            }

            if (res.data.user.employment_condition == null) {
              this.sel_wantedJobConditions = "";
            } else {
              this.sel_wantedJobConditions = res.data.user.employment_condition;
            }
            if (res.data.user.gender == "male") {
              this.sex = "male";
              $(".womenradio").removeClass("wchosen");
              $(".manradio").addClass("mchosen");
            } else {
              this.sex = "female";
              $(".manradio").removeClass("mchosen");
              $(".womenradio").addClass("wchosen");
            }
            this.loading = false;
          }
        })
        .catch(error => console.log(error));
    },

    doUpdateProfile() {
      this.loading = true;
      var cid = this.$route.params.cid;
      var uid = this.$route.params.uid;
      const thisVue = this;
      var formData = new FormData();
      formData.append("first_name", this.first_name);
      formData.append("last_name", this.last_name);
      if (this.imageBlob != "") {
        formData.append("image", this.imageBlob, "temp.png");
      }
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.loading = false;
        return;
      } else {
        axios
          .post(
            "/profile-edit?token=" + localStorage.getItem("token"),
            formData,
            {
              headers: { "X-localization": localStorage.getItem("lan") }
            }
          )
          .then(res => {
            if (res.data[0]) {
              this.$toaster.error(res.data[0]);
              this.$store.dispatch("logout");
            }
            if (!res.data.result) {
              if (res.data[0]) {
                this.$toaster.error(res.data[0]);
                this.$store.dispatch("logout");
              }
            } else {
              this.$router.push(
                "/company/company-user-profile/" + cid + "/" + uid
              );
              this.$toaster.success(thisVue.$t("success_edit_profile"));
            }
            this.loading = false;
          })
          .catch(() => {
            this.$toaster.error(thisVue.$t("err_network"));
          });
      }
    },
  }
};
</script>

<style scoped>
.company {
  width: 147px;
  height: 147px;
  border-radius: 100px;
}
.regnext_btn {
  width: 100%;
  height: 56px;
  font-weight: bold;
  font-size: 1rem;
}
.pman {
  width: auto;
  margin-top: 70px;
}

.slide_options {
  background-color: #f8fafa;
  border-radius: 30px;
  margin: 10px 0px;
  margin-top: 44px;
  padding: 5px 0px;
}

.slide_item {
  text-align: center;
  padding: 18px;
  cursor: pointer;
}

.spressed {
  text-align: center;
  padding: 18px;
  border-radius: 30px;
  background-color: #ffffff;
  box-shadow: 0 1px 2px 0 rgba(40, 60, 80, 0.12);
}

.slide_txt {
  font-size: 1rem;
  font-weight: bold;
  color: #b4bec8;
}

.spressed .slide_txt {
  font-size: 1rem;
  font-weight: bold;
  color: #3d7dd8;
}

.pview {
  margin-top: 38.5px;
  margin-bottom: 80px;
}

.avatar {
  width: 80%;
  border-radius: 100px;
}

.pgraytxt {
  opacity: 0.64;
  font-size: 1rem;
  font-weight: 500;
}

.cs_summary {
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5;
  margin-top: 21px;
}

.pvlabel {
  margin-left: 20px;
}

.pv_btnpanel {
  padding: 0px 10%;
}

.updatebtn {
  width: 100%;
  height: 56px;
}

.pv_showchart {
  background-color: #f8f8fa;
  margin-top: 16px;
}

.eview {
  padding: 30px 15px;
}

.chartboxes {
  display: block;
  margin: auto;
  margin-bottom: 30px;
  max-width: 200px;
  height: 100px;
}

.statustitle {
  font-size: 1.25rem;
  font-weight: bold;
  margin-top: 34px;
  margin-bottom: 0.1rem;
}

.statusnum {
  position: absolute;
  /*right: 46%;
      top: 55%;*/
  font-weight: bold;
  font-size: 1.5rem;
}

.caltxt {
  margin-top: 45px;
}

.calpanel {
  text-align: right;
}

.camera {
  box-shadow: 0 2px 4px 0 rgba(40, 60, 80, 0.12);
  background-color: #ffffff;
  border: solid 1px #c8d2dc;
  border-radius: 100px;
  padding: 8px 9px;
  position: absolute;
  top: 105px;
  right: 30px;
  cursor: pointer;
}

.camera:hover {
  background-color: #3d7dd8;
}

.camera:hover .fa-camera {
  color: white;
}

.camera .fa-camera {
  font-size: 20px;
  color: #3d7dd8;
}

.peditlabel {
  font-size: 1rem;
  font-weight: 500;
  margin-left: 20px;
  margin-top: 20px;
}

.peditinput {
  width: 100%;
  height: 44px;
  padding: 0px 16px;
  margin-left: 20px;
}

.pedittextarea {
  width: 100%;
  height: 188px;
  padding: 16px;
  margin-left: 20px;
}

.peselectboxs {
  float: left;
  margin-left: 20px;
}

.selectdiv select {
  height: 50px !important;
}

.peradioboxs {
  text-align: center;
  min-width: 128px;
  height: 50px;
  float: left;
  background-color: #ffffff;
  border: 1px solid #b4bec8;
  color: #b4bec8;
  margin-left: 20px;
  margin-top: 5px;
  padding-top: 10px;
  border-radius: 4px;
  cursor: pointer;
}

.manradio:hover,
.mchosen {
  border: 1px solid #3d7dd8;
  color: #3d7dd8;
}

.womenradio:hover,
.wchosen {
  border: 1px solid #f878c8;
  color: #f878c8;
}
.peradiotxt {
  font-size: 0.875rem;
  font-weight: bold;
}
.input input:focus select:focus {
  outline: none;
  border: 1px solid #3d7dd8;
  background-color: #eee;
}

.input.invalid label {
  color: red;
}

.input.invalid input {
  border: 1px solid red;
  background-color: #ffc9aa;
}
.linput {
  width: 423px;
}

.form-group {
  margin-bottom: 0px;
}

.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
}

.upload-btn-wrapper input[type="file"] {
  font-size: 100px;
  position: absolute;
  top: 105px;
  right: 30px;
  opacity: 0;
}

@media screen and (max-width: 1200px) {
  .camera {
    top: 80px;
    right: 20px;
  }

  .upload-btn-wrapper input[type="file"] {
    top: 80px;
    right: 20px;
  }
}

@media screen and (max-width: 992px) {
  .camera {
    top: 50px;
    right: 20px;
  }

  .upload-btn-wrapper input[type="file"] {
    top: 50px;
    right: 20px;
  }

  .linput {
    width: 100%;
  }
}

@media screen and (max-width: 768px) {
  .pman {
    margin-top: 0px;
  }

  .avatar {
    width: 50%;
  }

  .page_title {
    margin-top: 40px;
  }

  .pvlabel {
    margin-left: 0px;
  }

  .calpanel {
    text-align: center;
  }

  .camera {
    top: 80%;
    right: 20%;
  }

  .peditlabel {
    margin-left: 0px;
  }

  .peditinput {
    margin-left: 0px;
  }

  .pedittextarea {
    margin-left: 0px;
  }

  .peselectboxs {
    width: 100%;
    margin-left: 0px;
  }

  .peradioboxs {
    width: 100%;
    margin-left: 0px;
  }

  .help-block {
    margin-left: 0px;
    margin-top: 10px;
  }

  .upload-btn-wrapper input[type="file"] {
    top: 80%;
    right: 20%;
  }
}
</style>
